export { isMasterDataSaveNetworkError as isDcSaveNetworkError } from "./masterDataSaveErrors";

export const DC_CODE_ALREADY_EXISTS_MESSAGE =
  "This DC Code already exists for this purchaser.";

export const DC_SAVE_NETWORK_ERROR_MESSAGE =
  "Failed to save DC. Please try again later.";

export const DC_NAME_MAX_LENGTH = 255;
export const DC_CODE_MAX_LENGTH = 100;

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isDcCodeDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("dc code") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function createDcNameRules() {
  return [
    { required: true, message: "DC Name is required" },
    {
      max: DC_NAME_MAX_LENGTH,
      message: `DC Name must be less than or equal to ${DC_NAME_MAX_LENGTH} characters.`,
    },
  ];
}

export function createDcCodeRules() {
  return [
    { required: true, message: "DC Code is required" },
    {
      max: DC_CODE_MAX_LENGTH,
      message: `DC Code must be less than or equal to ${DC_CODE_MAX_LENGTH} characters.`,
    },
  ];
}
